import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center mb-4" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Alerts")
  ])
], -1)
const _hoisted_3 = {
  key: 0,
  class: "col-md-12 text-center mb-4"
}
const _hoisted_4 = {
  key: 1,
  class: "row"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "col-md-12 text-center mb-4" }, " This screen contains a repository of messages you’ve previously viewed which are stored here for historic reference ", -1)
const _hoisted_6 = { class: "table table-bordered table-striped" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", { class: "table-dark" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-center" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Message")
  ])
], -1)
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 2,
  class: "row"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "col-md-12 text-center mb-4" }, " No archived alerts", -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading..."))
      : ($setup.alerts.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("table", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.alerts, (alert) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: alert.AlertID
                  }, [
                    _createElementVNode("td", null, _toDisplayString($setup.useDateFormatter(alert.DateCreated)), 1),
                    _createElementVNode("td", {
                      innerHTML: alert.Message
                    }, null, 8, _hoisted_8)
                  ]))
                }), 128))
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
  ]))
}